import React from 'react';
import T from 'mrf/utils/T';

export default function ErrorTip({message, ...props }) {
    return <>
        <div
            className='text-xs italic tracking-wide text-error'
            {...props}
        >
            <T>{message}</T>
        </div>
    </>
}
